/** Shared viewport breakpoints (px). Used by useBreakpoint and CSS custom properties. */
export const BREAKPOINTS = {
  xs: 480,
  sm: 576,
  md: 768,
  lg: 1024,
  xl: 1200,
};
